import { SVGProps } from "react";

const STICrystal = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Crystal" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><path d="m46 200 56 210 210 56 154-154-56-210-210-56zm11 3 205-55-55 205z" /></svg>;

export { STICrystal };